import ApiService from "../Services/ApiService";

export type PasswordLinkPurpose = "reset" | "first_login";

/**
 * Lien de choix du mot de passe envoyé par notre serveur (mail aux couleurs
 * de la marque, page /auth/action de l'application). Route anonyme : la
 * réponse est toujours neutre, jamais « adresse inconnue ».
 */
export default abstract class PasswordLinkRepository {
    public static request(email: string, purpose: PasswordLinkPurpose): Promise<{ sent: boolean }> {
        return ApiService.post("/auth/v2/password-link", { email: email.trim(), purpose }) as Promise<{ sent: boolean }>;
    }
}
